import { joinWithSymbol } from './joinWithSymbol';

const joinWithMiddleDotSymbol = <T extends unknown[]>(arr: T) => joinWithSymbol(arr, '·');

export { joinWithMiddleDotSymbol };
